import Notification from '../vc-notification';
import LoadingOutlined from '@ant-design/icons-vue/LoadingOutlined';
import classNames from '../_util/classNames';
import CustomIcon from '../icon/index';
import { globalConfigForApi } from '../config-provider';
let defaultDuration = 3;
let defaultTop;
let messageInstance;
let key = 1;
let localPrefixCls = '';
let transitionName = 'move-up';
let hasTransitionName = false;
let getContainer = () => document.body;
let maxCount;
let rtl = false;
export function getKeyThenIncreaseKey() {
    return key++;
}
function setMessageConfig(options) {
    if (options.top !== undefined) {
        defaultTop = options.top;
        messageInstance = null; // delete messageInstance for new defaultTop
    }
    if (options.duration !== undefined) {
        defaultDuration = options.duration;
    }
    if (options.prefixCls !== undefined) {
        localPrefixCls = options.prefixCls;
    }
    if (options.getContainer !== undefined) {
        getContainer = options.getContainer;
        messageInstance = null; // delete messageInstance for new getContainer
    }
    if (options.transitionName !== undefined) {
        transitionName = options.transitionName;
        messageInstance = null; // delete messageInstance for new transitionName
        hasTransitionName = true;
    }
    if (options.maxCount !== undefined) {
        maxCount = options.maxCount;
        messageInstance = null;
    }
    if (options.rtl !== undefined) {
        rtl = options.rtl;
    }
}
function getMessageInstance(args, callback) {
    if (messageInstance) {
        callback(messageInstance);
        return;
    }
    Notification.newInstance({
        appContext: args.appContext,
        prefixCls: args.prefixCls || localPrefixCls,
        rootPrefixCls: args.rootPrefixCls,
        transitionName,
        hasTransitionName,
        style: { top: defaultTop },
        getContainer: getContainer || args.getPopupContainer,
        maxCount,
        name: 'message',
    }, (instance) => {
        if (messageInstance) {
            callback(messageInstance);
            return;
        }
        messageInstance = instance;
        callback(instance);
    });
}
// const typeToIcon = {
//   info: InfoCircleFilled,
//   success: CheckCircleFilled,
//   error: CloseCircleFilled,
//   warning: ExclamationCircleFilled,
//   loading: LoadingOutlined,
// };
const getTypeToIcon = (prefixCls, type) => {
    const iconsMap = {
        info: `${prefixCls}-tips_info_circle_fill`,
        success: `${prefixCls}-tips_check_circle_fill`,
        error: `${prefixCls}-tips_close_circle_fill`,
        warning: `${prefixCls}-tips_exclamation_circle_fill`,
        help: `${prefixCls}-tips_question_circle_fill`,
        loading: LoadingOutlined,
    };
    return iconsMap[type];
};
function notice(args) {
    const duration = args.duration !== undefined ? args.duration : defaultDuration;
    const target = args.key || getKeyThenIncreaseKey();
    const closePromise = new Promise(resolve => {
        const callback = () => {
            if (typeof args.onClose === 'function') {
                args.onClose();
            }
            return resolve(true);
        };
        getMessageInstance(args, instance => {
            const prefixCls = globalConfigForApi.getPrefixCls('message');
            let classList = '';
            if (args.class) {
                classList += args.class;
            }
            if (args.title) {
                classList += ` ${prefixCls}-notice-title`;
            }
            instance.notice({
                key: target,
                duration,
                style: args.style || {},
                class: classList,
                closable: args.closable,
                content: ({ prefixCls }) => {
                    const iconPrefixCls = globalConfigForApi.getPrefixCls('icon');
                    const Icon = getTypeToIcon(iconPrefixCls, args.type);
                    const iconNode = Icon ? (<CustomIcon icon-class={Icon} class={`${prefixCls}-notice-content__icon`}/>) : ('');
                    const messageClass = classNames(`${prefixCls}-custom-content`, {
                        [`${prefixCls}-${args.type}`]: args.type,
                        [`${prefixCls}-rtl`]: rtl === true,
                        [`${prefixCls}-title-content`]: !!args.title,
                    });
                    /** message内容 */
                    const messageContainer = args?.title ? (<div class={`${prefixCls}-notice-content__box`}>
              <p class={`${prefixCls}-notice-content__title`}>
                {typeof args.title === 'function' ? args.title() : args.title}
              </p>
              <span class={`${prefixCls}-notice-content__message`}>
                {typeof args.content === 'function' ? args.content() : args.content}
              </span>
            </div>) : (<span>{typeof args.content === 'function' ? args.content() : args.content}</span>);
                    /** 手动关闭message */
                    const onCloseMessage = () => {
                        const { removeNotice } = messageInstance;
                        removeNotice(target);
                        callback();
                    };
                    /** 关闭按钮 */
                    const closeIcon = args.closable ? (<button type="button" onClick={onCloseMessage} class={`${prefixCls}-close`}>
              <CustomIcon icon-class="wd-icon-tips_close"/>
            </button>) : null;
                    return (<div class={messageClass}>
              {typeof args.icon === 'function' ? args.icon() : args.icon || iconNode}
              {messageContainer}
              {closeIcon}
            </div>);
                },
                onClose: callback,
                onClick: args.onClick,
            });
        });
    });
    const result = () => {
        if (messageInstance) {
            messageInstance.removeNotice(target);
        }
    };
    result.then = (filled, rejected) => closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}
function isArgsProps(content) {
    return (Object.prototype.toString.call(content) === '[object Object]' &&
        !!content.content);
}
const api = {
    open: notice,
    config: setMessageConfig,
    destroy(messageKey) {
        if (messageInstance) {
            if (messageKey) {
                const { removeNotice } = messageInstance;
                removeNotice(messageKey);
            }
            else {
                const { destroy } = messageInstance;
                destroy();
                messageInstance = null;
            }
        }
    },
};
export function attachTypeApi(originalApi, type) {
    originalApi[type] = (content, duration, onClose) => {
        if (isArgsProps(content)) {
            return originalApi.open({ ...content, type });
        }
        if (typeof duration === 'function') {
            onClose = duration;
            duration = undefined;
        }
        return originalApi.open({ content, duration, type, onClose });
    };
}
['success', 'info', 'warning', 'error', 'loading'].forEach(type => attachTypeApi(api, type));
api.warn = api.warning;
/** @private test Only function. Not work on production */
export const getInstance = () => (process.env.NODE_ENV === 'test' ? messageInstance : null);
export default api;
